"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StopWatch = /** @class */ (function () {
    function StopWatch() {
    }
    StopWatch.prototype.start = function () {
        this.timeStart = new Date().getTime();
    };
    StopWatch.prototype.stop = function () {
        return new Date().getTime() - this.timeStart; // eslint-disable-line @typescript-eslint/no-non-null-assertion
    };
    return StopWatch;
}());
exports.default = StopWatch;
//# sourceMappingURL=StopWatch.js.map